import React from 'react';
import SocialLinks from './SocialLinks';
import '../styles/footer.css';

const Footer = () => {
	const currentYear = new Date().getFullYear();

	return (
		<footer>
			<p>
				&copy; {currentYear}	&nbsp; Junfel Velasco &nbsp; | &nbsp; <span> All Rigths Reserved.&nbsp; </span>
			</p>
			<SocialLinks />
		</footer>
	);
};

export default Footer;
